import { Link } from "react-router-dom";

import "./header.css";

const Header = () => {
  return (
    <div className="header">
      <div className="logo">
        <Link to="/">Price<b>Time</b></Link>
      </div>
      <div className="links">
        <Link to="addNewBooks">Add new books</Link>
        <Link to="myBookstores">My bookstores</Link>
        <span>|</span>
        <span>Logout</span>
      </div>
    </div>
  );
}

export default Header;